import { getAllTags, getTagData } from "api/tags";
import { getAllExpressions, getExpressionData } from "api/expression";

const allConfigurationApiConfig = {
  getAllTags,
  getTagData,
  getAllExpressions,
  getExpressionData
};

export default allConfigurationApiConfig;